/* global globalThis */

const CREDENTIAL_ERROR_PATTERNS = [
  /permission[-_\s]?denied/i,
  /auth\//i,
  /unauth/i,
  /credential/i,
  /token/i,
  /jwt/i,
  /forbidden/i,
  /not authorized/i,
]

const extractCredentialErrorText = (errorOrMessage) => {
  if (!errorOrMessage) return ""
  if (typeof errorOrMessage === "string") return errorOrMessage

  return [
    errorOrMessage.code,
    errorOrMessage.message,
    errorOrMessage.details,
    errorOrMessage.error,
  ]
    .filter(Boolean)
    .join(" ")
}

export const isCredentialError = (errorOrMessage) => {
  const errorText = extractCredentialErrorText(errorOrMessage)
  if (!errorText) return false

  return CREDENTIAL_ERROR_PATTERNS.some((pattern) => pattern.test(errorText))
}

export const dispatchCredentialLogout = (detail = {}) => {
  globalThis.dispatchEvent(new CustomEvent("jwt-error", { detail }))
}

export const handleCredentialError = (errorOrMessage) => {
  if (!isCredentialError(errorOrMessage)) return false

  dispatchCredentialLogout({
    source: "credential-error",
    error: extractCredentialErrorText(errorOrMessage),
  })
  return true
}